import { authClient } from '@/lib/auth-client';
import { Avatar, Menu, Text, UnstyledButton } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';

export default function HeaderUser() {
  const { data } = authClient.useSession();
  const user = data?.user;

  function logout() {
    authClient.signOut();
  }

  return (
    <Menu>
      <Menu.Target>
        <UnstyledButton>
          <Avatar src={user?.image} alt={user?.name} radius="xl" />
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown>
        <div css={{ padding: 'var(--mantine-spacing-xs) var(--mantine-spacing-sm)' }}>
          <Text size="sm">{user?.email}</Text>
          <Text c="dimmed">{user?.name}</Text>
        </div>

        <Menu.Divider />

        <Menu.Item leftSection={<IconLogout />} onClick={logout}>
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
